import { useState, useEffect, useCallback } from 'react';
import { safeFetch } from '@go-client/lib/api';
import { groupResourceClient } from '@go-client/lib/api/v2/groupResource';
import {
  BrandGroupResourceTypeSchema as GroupResourceTypeSchema,
  BrandGroupResourceType as GroupResourceType,
} from '@go-shared/types/zod/brand';
import z from 'zod';
import { User, UserSchema } from '@go-shared/types/zod/user';
import { userClient } from '@go-client/lib/api/v2/user';

type GroupResourceTypeResponse = {
  resourceTypes: GroupResourceType[];
  users: User[];
};
export function useGroupResourceData(brandId: string) {
  const [resourceData, setResourceData] = useState<GroupResourceTypeResponse>({
    resourceTypes: [],
    users: [],
  });
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await safeFetch(
        groupResourceClient.getResourcesTypes({
          params: { brandId },
        }),
        z.object({
          resourceTypes: GroupResourceTypeSchema.array(),
        })
      );

      const userRes = await safeFetch(userClient.findAll(), UserSchema.array());

      setResourceData({ ...res, users: userRes });
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [brandId]);

  useEffect(() => {
    fetchData();
  }, [brandId]);

  return {
    resourceData,
    loading,
    setLoading,
    refreshTypesAndUsers: fetchData,
  };
}
